/** @format */

export class NamedException {
    public id: string;
    public message: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    public constructor(id: string, message: any) {
        this.id = id;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        this.message = message;
    }
}
